import shipperInvoiceEmail from './shipperInvoiceSlice';

export * from './shipperInvoiceSlice';

export default shipperInvoiceEmail;
